type LetterSpacing = 'normal' | `.${number}em`

const definition = {
    normal: 'normal',
    caps: '.025em',
    loose: '.02em',
} satisfies Record<string, LetterSpacing>

export const letterSpacings: { [K in keyof typeof definition]: LetterSpacing } = definition
